import { forwardRef } from 'react';
import { cn } from '../../util';

interface TableCellProps extends React.ThHTMLAttributes<HTMLTableCellElement> {
  className?: string;
}

const TableCell = forwardRef<HTMLTableCellElement, TableCellProps>(({ className, ...props }, ref) => (
  <td
    ref={ref}
    className={cn(
      'py-4 align-middle [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px] [table[data-compact]_&]:py-2 [table[data-compact]_&]:text-sm',
      className
    )}
    {...props}
  />
));
TableCell.displayName = 'TableCell';

export default TableCell;
